<template>
  <div class="SiteSettings">
    <h2>{{ $t('settings') }}</h2>
    <Field
      v-for="field in settings"
      :key="field.key"
      v-bind="field"
      @update:value="setValue(field.key, $event)" />
  </div>
</template>

<script>
import { getters } from '@utils'

export default {
  props: {
    value: Object,
  },
  computed: {
    settings() {
      return this.formSiteSettings(this.value)
    },
    ...getters('formSiteSettings'),
  },
  methods: {
    setValue(keyToSet, valueToSet) {
      const settings = Object
        .fromEntries(Object
          .entries(this.settings)
          .map(([key, { value }]) => [
            key,
            keyToSet === key
              ? valueToSet
              : value,
          ]))

      this.$up('value', settings)
    },
  },
}
</script>

<style lang="scss">
.SiteSettings {
}
</style>

<i18n>
{
  "en": {
    "settings": "Settings"
  }
}
</i18n>
